import { render } from "./SecretSociety.vue?vue&type=template&id=a558acb4"
import script from "./SecretSociety.vue?vue&type=script&lang=js"
export * from "./SecretSociety.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/society/SecretSociety.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a558acb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a558acb4', __exports__)) {
    api.reload('a558acb4', __exports__)
  }
  
  module.hot.accept("./SecretSociety.vue?vue&type=template&id=a558acb4", () => {
    api.rerender('a558acb4', render)
  })

}


export default __exports__